import NewReceiptMultiple from '../../pages/Receipt/NewReceiptMultiple';
import React, { useState } from 'react';
import * as yup from 'yup';

const NewReceiptMultipleContainer = ({ closeModal }) => {
	const [stage2, setStage2] = useState(true);
	const [receiptSummary, setReceiptSummary] = useState(false);

	const goToStage2 = () => {
		setStage2(true);
	};

	const goToReceiptSummary = () => {
		setReceiptSummary(true);
		setStage2(false);
	};

	return (
		<NewReceiptMultiple
			closeModal={closeModal}
			stage2={stage2}
			goToStage2={goToStage2}
			receiptSummary={receiptSummary}
			goToReceiptSummary={goToReceiptSummary}
		/>
	);
};

export default NewReceiptMultipleContainer;
